import produce from 'immer';
import { AnyAction } from 'redux';
import {
  FETCH_OMNI_SEARCH_NFTS_ERROR,
  FETCH_OMNI_SEARCH_NFTS_LOADING,
  FETCH_OMNI_SEARCH_NFTS_SUCCESS
} from 'appRedux/ActionTypes';
import { defaultMeta } from 'constants/dataListMeta';
import { IMeta, INft } from 'interfaces';

type InitialStateType = {
  loading: boolean;
  loaded: boolean;
  error: string;
  data: INft[];
  meta: IMeta;
  current: {
    loading: boolean;
    error: string;
    data?: INft;
  };
};

export const INIT_STATE: InitialStateType = {
  loading: false,
  loaded: false,
  error: '',
  data: [],
  meta: defaultMeta,
  current: {
    loading: false,
    error: '',
    data: undefined
  }
};

export const OmniSearchNftsReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_OMNI_SEARCH_NFTS_LOADING:
        draft.loading = true;
        draft.loaded = false;
        draft.error = '';
        break;

      case FETCH_OMNI_SEARCH_NFTS_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        draft.data = action.payload.data;
        draft.meta = action.payload.meta;
        break;

      case FETCH_OMNI_SEARCH_NFTS_ERROR:
        draft.loading = false;
        draft.loaded = true;
        draft.error = action.payload;
        break;
    }
  });
